import React from "react";
import {
  FaTruck,
  FaShieldAlt,
  FaHeadset,
  FaRecycle,
} from "react-icons/fa";
import "./AboutNepliShop.css";

const AboutNepliShop = () => {
  return (
    <div className="about-neplishop">
      <div className="about-container">
        {/* Logo and Tagline */}
        <div className="about-header">
          <h2 className="about-title">NepliShop</h2>
          <p className="about-tagline">
            Your Trusted Online Shopping Destination in Nepal
          </p>
          <p className="about-description">
            We bring you the latest fashion trends, quality products, and
            exceptional service right to your doorstep across Nepal.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="mission-vision">
          <div className="mission">
            <h3>Our Mission</h3>
            <p>
              To make online shopping accessible, reliable, and enjoyable for
              every Nepali by offering quality products at affordable prices
              with seamless delivery.
            </p>
          </div>
          <div className="vision">
            <h3>Our Vision</h3>
            <p>
              To become Nepal's most trusted e-commerce platform,
              revolutionizing the way people shop online with innovation and
              customer-centric approach.
            </p>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="why-choose-us">
          <h3>Why Choose NepliShop?</h3>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">
                <FaTruck />
              </div>
              <h4>Free Delivery</h4>
              <p>Free shipping across Nepal on orders above Rs. 1500</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <FaShieldAlt />
              </div>
              <h4>Secure Shopping</h4>
              <p>100% secure payment & data protection guaranteed</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <FaHeadset />
              </div>
              <h4>24/7 Support</h4>
              <p>Round-the-clock customer support via chat & phone</p>
            </div>

            <div className="feature">
              <div className="feature-icon">
                <FaRecycle />
              </div>
              <h4>Easy Returns</h4>
              <p>7-day easy return policy for all products</p>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div>
          Neplishop is not Just a Online Shopping Platform its a medium of
          Connecting People Thorough Our Services and Trust. Here We Provide You
          Affordable Price of Clothes and Make You Look Stylish and Fashionable.
          Our Aim is to Make Our Brand Neplishop Top 1 in All Over The Nepal
          Since Nepali Brand are Not That Popular, All the Nepali Online
          Shopping Platform is Affiliated with Outside of Nepal But our Brand
          Neplishop is Fully Based on Nepal Created by Nepali Founders, But For
          That We Need Your Support and Trust Towards Us, and We Assure That You
          will Never Be Disappoint From Our Services and Goods. We Provide You
          Free Shipping inside the Kathmandu Valley About Founders We are Three
          Friends Studying Our Bachelor in Kathmandu doing nothing but one Day
          suddenly we got an idea of Opening Our Own Brand That is Fully Based
          on Clothes and Shoes For Men, Women and Kids that is in affordable
          price for everyone. We are a Youth Who want to grow our brand and make
          it a large company. Our Primary Target is To Satisfy Our Customer
          Needs and Make Them Happy From Our Service. Now you maybe thinking How
          These Three Idiots Got an Idea of Creating a Nepali Based Online
          Shopping Platform? So, The Answer is Simple we Were Inspired from
          Content Creator of Our Social Media They Does The Same But the only
          Difference is that They Don't Have any Proper Goal and Guidance about
          their work, They Just Post Their Content and then Sell Product and
          later on the product is dammanged or useless when delivered to
          customer we have that experience so, we decided that we will change it
          and make customer believe that online shopping is possible without a
          failed or damaged product.
        </div>


        {/* Contact Info */}
        <div className="contact-info">
          <h3>Get In Touch</h3>
          <div className="contact-details">
            <p>
              <strong>Email:</strong> support@neplishop.com
            </p>
            <p>
              <strong>Phone:</strong> +977 97417614069
            </p>
            <p>
              <strong>Address:</strong> Kathmandu, Nepal
            </p>
            <p>
              <strong>Business Hours:</strong> 9:00 AM - 8:00 PM (NPT)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutNepliShop;
